/**
* Created by bieao on 2020/4/1.
*/
<template>
    <div class="item-position project-overview" :style="isXL ? {top: '320px'} : {}">
      <div class="title-item">
        <div class="first"></div>
        <div class="two">02</div>
        <div class="title">
          <div>Overview</div>
          <div>概览</div>
        </div>
      </div>
      <div class="overview-crane m-b-10">
        <div class="m-r-5">塔机总数：</div>
        <div>{{overview.craneTotal}}</div>
      </div>
      <div class="overview-crane m-b-10">
        <div class="m-r-5">在线总数：</div>
        <div>{{overview.online}}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Overview',
  props: {
    overview: {
      type: Object
    },
    isXL: {
      type: Boolean
    }
  }
}
</script>

<style scoped lang="scss">
  .project-overview{
    left: 10px;
    top: 380px;
    .overview-crane{
      width:170px;
      height:50px;
      display: flex;
      align-items: center;
      padding:0 20px;
      background-size: 100% 100%;
      background: url('/static/img/item-bg200x50.png') center center no-repeat;
      div:first-child{
        font-size: 14px;
      }
      div:nth-child(2){
        color:#49d5f3;
        font-size: 18px;
      }
    }
    .overview-status{
      width:260px;
      height:50px;
      display: flex;
      align-items: center;
      padding:0 20px;
      background-size: 100% 100%;
      background: url('/static/img/item-bg300x50.png') center center no-repeat;
      .status-item{
        display: flex;
        align-items: center;
        span:first-child{
          font-size: 14px;
        }
        span:nth-child(2){
          color:#49d5f3;
          font-size: 18px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Overview.vue